import type { KeyboardEvent } from "react"
import designSystemStyles from "@shared/styles/designSystemStyles";
import { HorizontalContainer } from "./Containers"
import { Text, SmallText } from "./Texts"
import styles from "@shared/styles/components/UserCard.module.css"
interface UserCardProps {
    name: string;
    subtitle?: string;
    imageURL?: string;
    className?: string;
    width?: string;
    onClick?: () => void;
}

const UserCard = ({ name, subtitle, imageURL, className, width, onClick }: UserCardProps) => {
    const nameParts = name
        .trim()
        .split(/\s+/)
        .filter(Boolean);
    const initials = nameParts.length
        ? (nameParts.length === 1
            ? nameParts[0][0]
            : `${nameParts[0][0]}${nameParts[nameParts.length - 1][0]}`)
            .toUpperCase()
        : '?';

    const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
        if (!onClick) return
        if (event.key === "Enter" || event.key === " ") {
            event.preventDefault()
            onClick()
        }
    }

    const content = (
        <HorizontalContainer
            gap={designSystemStyles.gapSm}
            alignment="center"
            className={onClick ? undefined : ['DSUserCard', className].filter(Boolean).join(' ')}
            width={onClick ? "100%" : width}
        >
            <div style={{
                width: '36px',
                height: '36px',
                borderRadius: '50%',
                border: `1px solid ${designSystemStyles.colorUserInitialsBorder}`,
                borderColor: designSystemStyles.colorUserInitialsBorder,
                backgroundColor: designSystemStyles.colorUserInitialsBackground,
                backgroundImage: imageURL ? `url(${imageURL})` : undefined,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
            }}>
                {!imageURL && (
                    <span style={{
                        fontWeight: designSystemStyles.fontWeightTitle,
                        color: designSystemStyles.colorTitleText,
                        fontSize: designSystemStyles.fontSizeXsm,
                    }}>
                        {initials}
                    </span>
                )}
            </div>
            <div className={styles["name-container"]}>
                <Text className={styles["name-text"]} text={`**${name.trim()}**`} markdown={true} title={name.trim()} truncate />
                {subtitle && (
                    <SmallText
                        className={styles["name-text"]}
                        text={subtitle}
                        color={designSystemStyles.colorTextSecondary}
                        title={subtitle}
                        truncate
                    />
                )}
            </div>
        </HorizontalContainer>
    )

    if (!onClick) {
        return content
    }

    return (
        <div
            className={['DSUserCard', styles.clickable, className].filter(Boolean).join(' ')}
            style={{ width }}
            onClick={onClick}
            role="button"
            tabIndex={0}
            onKeyDown={handleKeyDown}
        >
            {content}
        </div>
    )
}
export default UserCard
